const contactSupportEN = {
	title: "Contact Support",
	support: {
		title: "Need Help?",
		text: "If you have any questions, run into issues, or need help using ReservaSinFila, our team is here to assist you.",
	},
	email: {
		title: "Support Email",
		text: "You can reach us anytime at:",
	},
	response: {
		title: "Response Time",
		text: "We aim to respond within 24 hours, and usually much faster during business days.",
	},
};

export default contactSupportEN;

